import { Component } from "react";
import { func, number, string } from "prop-types";
import { Link } from "react-router-dom";

import { routes } from "../../constants/routes";

class Categories extends Component {
  constructor(props) {
    super(props);

    this.getCategories = this.getCategories.bind(this);

    this._isMounted = false;

    this.state = {
      categories: [],
      error: null,
      loading: true,
    };
  }

  /**
   * Get categories breadcrumb from redux store
   * @public
   */
  getCategories() {
    const { id, categoriesCount, categoriesError, lookupCategory } = this.props;

    if (!!categoriesError || !id) {
      this.setState({ categories: [], error: categoriesError, loading: false });
      return false;
    }

    if (!categoriesCount) {
      this.setState({ categories: [], error: null, loading: true });
      return false;
    }

    lookupCategory(id, true)
      .then(response => {
        if (this._isMounted) {
          this.setState({
            categories: response.category,
          });

          const categoryNames = response.category.reduce(
            (names, { name }) => [...names, name],
            []
          );

          if (!!this.props.set) {
            this.props.set(categoryNames);
          }
        }
      })
      .catch(error => {
        if (this._isMounted) {
          this.setState({ error: error.message || "Error" });
        }
      })
      .then(() => {
        if (this._isMounted) {
          this.setState({ loading: false });
        }
      });
  }

  componentDidMount() {
    this._isMounted = true;
    this.getCategories();
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      prevProps.categoriesError !== this.props.categoriesError &&
      this.props.categoriesError !== this.state.error
    ) {
      if (this._isMounted) {
        this.setState({ error: this.props.categoriesError });
      }
    } else if (prevProps.categoriesCount !== this.props.categoriesCount) {
      this.getCategories();
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  render() {
    const { className } = this.props;
    const { categories, error, loading } = this.state;

    if (!!error) {
      return null;
    }

    return (
      <div className={className}>
        {!error && loading && (
          <span className="categories-loading">loading…</span>
        )}
        {!error &&
          !loading &&
          !!categories.length &&
          categories.map((category, index) => (
            <span className="category" key={index}>
              <Link
                to={{
                  pathname: routes.results.path,
                  search: `?category_id=${category.id}`,
                }}
              >
                {category.name}
              </Link>
              {index + 1 < categories.length ? (
                <span className="category-separator"> / </span>
              ) : (
                ""
              )}
            </span>
          ))}
      </div>
    );
  }
}

Categories.propTypes = {
  categoriesCount: number,
  categoriesError: string,
  className: string,
  lookupCategory: func.isRequired,
  set: func,
};

export default Categories;
